import * as React from "react";
const SvgFiRrLuchador = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-luchador_svg__a)">
      <path
        fill="#062147"
        d="M17 16h-2a2 2 0 0 1-2-2v-1a3 3 0 0 1 3-3h1a1 1 0 0 0 1-1 1 1 0 1 1 2 0v4a3 3 0 0 1-3 3m-1-4a1 1 0 0 0-1 1v1h2a1 1 0 0 0 1-1v-1.17c-.322.112-.66.17-1 .17zm-7 4H7a3 3 0 0 1-3-3V9a1 1 0 0 1 2 0 1 1 0 0 0 1 1h1a3 3 0 0 1 3 3v1a2 2 0 0 1-2 2m-3-4.17V13a1 1 0 0 0 1 1h2v-1a1 1 0 0 0-1-1H7c-.341 0-.68-.057-1-.17M19 24h-1.037a4 4 0 0 1-3.512-2.085l-.371-.68a2.37 2.37 0 0 0-4.16 0l-.371.68A4 4 0 0 1 6.037 24H5a5.006 5.006 0 0 1-5-5v-6.635A12.25 12.25 0 0 1 11.775 0 12 12 0 0 1 24 12v7a5.006 5.006 0 0 1-5 5m-7-6a4.37 4.37 0 0 1 3.836 2.277l.37.681A2 2 0 0 0 17.964 22H19a3 3 0 0 0 3-3v-7A10 10 0 0 0 11.812 2 10.24 10.24 0 0 0 2 12.365V19a3 3 0 0 0 3 3h1.037a2 2 0 0 0 1.756-1.042l.37-.68A4.37 4.37 0 0 1 12 18"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-luchador_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLuchador;
